import { ApplicationFormAnswers } from '../../../components/ApplicationForm/ApplicationFormContext'
import { VehicleDetailsDataObject } from '../../../services/vehicle-service'
import { Mapper, Ctx } from '../core/types'
import { mapAddressHistoryDefault } from '../domain/address'
import { mapEmploymentHistoryDefault } from '../domain/employment'
import { keepValue } from '../dsl/blocks'

export const defaultMappers = {
    addressHistory: ((_: any, ctx: Ctx) => mapAddressHistoryDefault(ctx.answers)) as Mapper<ApplicationFormAnswers['addressHistory']>,
    contactNumber: keepValue<string>(),
    drivingLicence: keepValue<string>(),
    emailAddress: keepValue<string>(),
    employmentHistory: ((_: any, ctx: Ctx) => mapEmploymentHistoryDefault(ctx.answers)) as Mapper<ApplicationFormAnswers['employmentHistory']>,
    loanAmount: keepValue<string>(),
    maritalStatus: keepValue<string>(),
    monthlyIncome: keepValue<number>(),
    personalDetails: ((v: any) => ({
        dateOfBirth: v.dateOfBirth,
        firstName: v.firstName,
        surname: v.surname
    })) as Mapper<ApplicationFormAnswers['personalDetails']>,
    title: keepValue<string>(),
    vehicleType: keepValue<string>(),
    vehicleDetails: keepValue<VehicleDetailsDataObject>()
}


